import {
  BedDoubleIcon,
  BriefcaseIcon,
  CoffeeIcon,
  FactoryIcon,
  HandCoinsIcon,
  HeartPulseIcon,
  LineChartIcon,
  MapPinnedIcon,
  PackageIcon,
  ReceiptIcon,
  StoreIcon,
  WalletIcon,
} from 'lucide-react'
import type { SolutionSummary } from '../../types/solution'

export const solutionCatalog: Record<string, SolutionSummary> = {
  retail: {
    slug: 'retail',
    title: 'Retail',
    kind: 'industry',
    icon: StoreIcon,
    copy: 'Sell faster and keep stock under control.',
    image: 'https://cdn.magicpatterns.com/uploads/hrSxrDybaWkqRaXzBR7V3y/ChatGPT_Image_Sep_26,_2026,_04_09_02_PM-1.png',
    alt: 'Shopkeeper arranging products on shelves in a busy Kigali shop',
    href: '/solutions/retail',
  },
  'food-beverage': {
    slug: 'food-beverage',
    title: 'Food & Beverage',
    kind: 'industry',
    icon: CoffeeIcon,
    copy: 'Manage orders, ingredients, and daily sales.',
    image: 'https://cdn.magicpatterns.com/uploads/um4PVUwRMuB6Dq6iSx7Up4/ChatGPT_Image_Sep_26,_2026,_04_09_05_PM-4.png',
    alt: 'Chef plating food beside an order screen in a restaurant kitchen',
    href: '/solutions/food-beverage',
  },
  manufacturing: {
    slug: 'manufacturing',
    title: 'Manufacturing',
    kind: 'industry',
    icon: FactoryIcon,
    copy: 'Track materials, production, and finished goods.',
    image: 'https://cdn.magicpatterns.com/uploads/c8Nf8XJGRxSAWm6B5i5fj7/ChatGPT_Image_Sep_26,_2026,_04_09_09_PM-1.png',
    alt: 'Worker inspecting finished goods in a small manufacturing workshop',
    href: '/solutions/manufacturing',
  },
  services: {
    slug: 'services',
    title: 'Services',
    kind: 'industry',
    icon: BriefcaseIcon,
    copy: 'Manage clients, jobs, and payments in one place.',
    image: 'https://cdn.magicpatterns.com/uploads/6bTCAA9T5mAFwtdRuNtBvU/ChatGPT_Image_Sep_26,_2026,_04_09_11_PM-2.png',
    alt: 'Service professional meeting a client across a desk in a small office',
    href: '/solutions/services',
  },
  hospitality: {
    slug: 'hospitality',
    title: 'Hospitality',
    kind: 'industry',
    icon: BedDoubleIcon,
    copy: 'Track bookings, guests, and property income.',
    image: 'https://cdn.magicpatterns.com/uploads/kif38iqadZcEesbQLKpsTR/ChatGPT_Image_Sep_26,_2026,_04_09_03_PM-2.png',
    alt: 'Hotel receptionist checking in a guest with a suitcase at the front desk',
    href: '/solutions/hospitality',
  },
  healthcare: {
    slug: 'healthcare',
    title: 'Healthcare',
    kind: 'industry',
    icon: HeartPulseIcon,
    copy: 'Manage pharmacy sales, clinic services, stock, and payments.',
    image: 'https://cdn.magicpatterns.com/uploads/iDUc4UaB1F5bDm8tDia9dE/ChatGPT_Image_Sep_26,_2026,_04_09_04_PM-3.png',
    alt: 'Pharmacist serving a customer at a neighbourhood pharmacy counter',
    href: '/solutions/healthcare',
  },
  'sell-and-get-paid': {
    slug: 'sell-and-get-paid',
    title: 'Sell and get paid',
    kind: 'need',
    icon: WalletIcon,
    copy: 'Accept every payment method and see it all in one place.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/3337d727-47db-441c-a01d-c53990988475.jpg',
    alt: 'Business owner taking a payment at her shop counter',
    href: '/solutions/sell-and-get-paid',
  },
  'manage-inventory': {
    slug: 'manage-inventory',
    title: 'Manage inventory',
    kind: 'need',
    icon: PackageIcon,
    copy: 'Know what’s in stock, what’s selling, and when to reorder.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/ab0101ab-8ad6-4588-83d1-46af0a029122.jpg',
    alt: 'Owner checking stock on shelves in a storeroom',
    href: '/solutions/manage-inventory',
  },
  'control-expenses': {
    slug: 'control-expenses',
    title: 'Control expenses',
    kind: 'need',
    icon: ReceiptIcon,
    copy: 'Record every cost and see where your money goes.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/c428e88a-0bce-4050-a006-e40f44c2650d.jpg',
    alt: 'Business owner recording expenses at her desk',
    href: '/solutions/control-expenses',
  },
  'understand-performance': {
    slug: 'understand-performance',
    title: 'Understand performance',
    kind: 'need',
    icon: LineChartIcon,
    copy: 'See sales, profit, and cash flow without waiting for month end.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/bf8c75d0-c0c3-451c-b8e2-c025c368382a.jpg',
    alt: 'Owner reviewing business reports on a laptop',
    href: '/solutions/understand-performance',
  },
  'manage-multiple-locations': {
    slug: 'manage-multiple-locations',
    title: 'Manage multiple locations',
    kind: 'need',
    icon: MapPinnedIcon,
    copy: 'Run every branch from one workspace.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/7aa8a4e9-9a2a-4af7-9800-98796172e259.jpg',
    alt: 'A busy Kigali shopping street with several shopfronts',
    href: '/solutions/manage-multiple-locations',
  },
  'access-business-finance': {
    slug: 'access-business-finance',
    title: 'Access business financing',
    kind: 'need',
    icon: HandCoinsIcon,
    copy: 'Turn your records into access to working capital.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/55a948a8-f1a2-4b85-9533-52b1fa01fe2f.jpg',
    alt: 'Business owner reviewing her business records with an adviser',
    href: '/solutions/access-business-finance',
  },
}
